enum SDSOutboundStatuses {
  'driver-preslot' = 1,
  'driver' = 2,
  'processing' = 3,
  'complete' = 4
}

export default SDSOutboundStatuses;



// WEBPACK FOOTER //
// ./src/enum/SDS-outbound-status.enum.ts